/** CoStar.Api.ListingAlert.ViewModels.BobPlayer.ProcessStatus */
export var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus[ProcessStatus["Unprocessed"] = 1] = "Unprocessed";
    ProcessStatus[ProcessStatus["Failed"] = 5] = "Failed";
    ProcessStatus[ProcessStatus["Succeeded"] = 10] = "Succeeded";
})(ProcessStatus || (ProcessStatus = {}));
